import React from "react";
import { Input } from 'antd';

function SearchInput(config) {
  return (
    <Input
      placeholder={config.placeholder}
      defaultValue={config.defaultValue}
      onChange={
        e => {
          this.handleInputChange(
            e.target.value,
            config.key
          )
        }
      }
      style={{ width: "75%", float: "right" }}
    />
  )
}

export default SearchInput;